export const emptyIfNull = value => value || '';

export const currencyTagFormat = value => value.toFixed(2).replace(/\./g, ',');

export const capitalizeFirst = value =>
  `${value.charAt(0).toUpperCase()}${value.toLowerCase().substr(1)}`;

export const undefinedIfEmpty = value => (value === '' ? undefined : value);
